/**
 * Hotel-specific general validations for passenger selection
 * İmza: (values, incrementValues, settings) => { errors }
 */
export const hotelGuestGeneralValidations = (values, incrementValues, settings) => {
  const errors = {};

  const total = Object.values(incrementValues).reduce(
    (sum, val) => sum + (typeof val === "number" ? val : 0),
    0,
  );

  // Total max
  if (settings?.totalSelections !== undefined && total > settings.totalSelections) {
    errors.general = {
      titleKey: "hotel.guestMaxTitle",
      descriptionKey: "hotel.guestMaxDescription",
    };
  }

  // Total min
  if (settings?.minTotalSelections !== undefined && total < settings.minTotalSelections) {
    errors.general = {
      titleKey: "hotel.guestMinTitle",
      descriptionKey: "hotel.guestMinDescription",
    };
  }

  return { errors };
};


